(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dani-FAQ"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-faq-seccion]').forEach(function(seccion) {
      var tabs = seccion.querySelectorAll('[data-faq-tab]');
      var paneles = seccion.querySelectorAll('[data-faq-panel]');
      var indicador = seccion.querySelector('[data-faq-indicador]');

      function posicionarIndicador(tab) {
        if (!indicador || !tab) return;
        var rect = tab.getBoundingClientRect();
        var contenedor = tab.parentElement;
        var contRect = contenedor.getBoundingClientRect();
        var paddingStr = getComputedStyle(contenedor).paddingLeft;
        var padding = parseFloat(paddingStr) || 0;
        var left = rect.left - contRect.left - padding;
        indicador.style.width = rect.width + 'px';
        indicador.style.transform = 'translateX(' + left + 'px)';
      }

      if (tabs.length > 0 && indicador) {
        var primera = seccion.querySelector('.faq-tab--activa') || tabs[0];
        requestAnimationFrame(function() {
          posicionarIndicador(primera);
        });

        window.addEventListener('resize', function() {
          var activa = seccion.querySelector('.faq-tab--activa');
          posicionarIndicador(activa);
        });
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var id = this.getAttribute('data-faq-tab');
          tabs.forEach(function(t) {
            t.classList.remove('faq-tab--activa');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('faq-tab--activa');
          this.setAttribute('aria-selected', 'true');
          paneles.forEach(function(panel) {
            if (panel.getAttribute('data-faq-panel') === id) {
              panel.classList.add('faq-panel--activo');
            } else {
              panel.classList.remove('faq-panel--activo');
              panel.querySelectorAll('details[open]').forEach(function(d) { d.removeAttribute('open'); });
            }
          });
          posicionarIndicador(this);
        });
      });

      var detalles = seccion.querySelectorAll('.faq-item');
      detalles.forEach(function(det) {
        det.addEventListener('toggle', function() {
          if (this.open) {
            detalles.forEach(function(otro) {
              if (otro !== det && otro.open) otro.removeAttribute('open');
            });
          }
        });
      });

      var scrollContenedor = seccion.querySelector('[data-faq-tabs]');
      var scrollThumb = seccion.querySelector('[data-faq-scroll-thumb]');
      var scrollIndicador = seccion.querySelector('[data-faq-scroll-indicador]');

      if (scrollContenedor && scrollThumb && scrollIndicador) {
        function actualizarIndicador() {
          var scrollWidth = scrollContenedor.scrollWidth;
          var clientWidth = scrollContenedor.clientWidth;
          if (scrollWidth <= clientWidth + 2) {
            scrollIndicador.style.display = 'none';
            return;
          }
          scrollIndicador.style.display = '';
          var ratio = clientWidth / scrollWidth;
          var thumbAnchoPct = Math.max(8, ratio * 100);
          scrollThumb.style.width = thumbAnchoPct + '%';
          var maxScroll = scrollWidth - clientWidth;
          var scrollActual = scrollContenedor.scrollLeft;
          var progreso = maxScroll > 0 ? scrollActual / maxScroll : 0;
          var maxLeftPct = 100 - thumbAnchoPct;
          var leftPct = progreso * maxLeftPct;
          scrollThumb.style.transform = 'translateX(0)';
          scrollThumb.style.left = leftPct + '%';
        }

        actualizarIndicador();

        scrollContenedor.addEventListener('scroll', function() {
          window.requestAnimationFrame(actualizarIndicador);
        });

        window.addEventListener('resize', function() {
          window.requestAnimationFrame(actualizarIndicador);
        });

        if (window.ResizeObserver) {
          var ro = new ResizeObserver(function() { actualizarIndicador(); });
          ro.observe(scrollContenedor);
        }

        setTimeout(actualizarIndicador, 100);
        setTimeout(actualizarIndicador, 500);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-feed-instagran"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.feed-ig-seccion').forEach(function(seccion) {
      var enlaces = seccion.querySelectorAll('.feed-ig-media-link');
      enlaces.forEach(function(enlace) {
        var video = enlace.querySelector('[data-feed-ig-video]');
        if (!video) return;

        var playRequest = null;

        function reproducir() {
          try {
            video.currentTime = 0;
            playRequest = video.play();
            if (playRequest && typeof playRequest.catch === 'function') {
              playRequest.catch(function() {});
            }
          } catch (e) {}
        }

        function pausar() {
          try {
            if (playRequest && typeof playRequest.then === 'function') {
              playRequest.then(function() { video.pause(); }).catch(function() {});
            } else {
              video.pause();
            }
          } catch (e) {}
        }

        enlace.addEventListener('mouseenter', reproducir);
        enlace.addEventListener('mouseleave', pausar);
        enlace.addEventListener('focusin', reproducir);
        enlace.addEventListener('focusout', pausar);

        if (window.matchMedia('(hover: none)').matches) {
          var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                reproducir();
              } else {
                pausar();
              }
            });
          }, { threshold: [0, 0.5, 1] });
          observer.observe(video);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-footer01"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFmdFooter(footer) {
    if (!footer || footer.dataset.fmdInit === 'true') return;
    footer.dataset.fmdInit = 'true';

    var desplegables = footer.querySelectorAll('[data-fmd-desplegable]');
    if (!desplegables.length) return;

    desplegables.forEach(function (det) {
      var summary = det.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        var estaAbierto = det.hasAttribute('open');
        if (!estaAbierto) {
          desplegables.forEach(function (otro) {
            if (otro !== det && otro.hasAttribute('open')) {
              otro.removeAttribute('open');
            }
          });
        }
      });
    });

    document.addEventListener('click', function (e) {
      desplegables.forEach(function (det) {
        if (det.hasAttribute('open') && !det.contains(e.target)) {
          det.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        desplegables.forEach(function (det) {
          if (det.hasAttribute('open')) det.removeAttribute('open');
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fmd-footer]').forEach(initFmdFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var footer = e.target.querySelector('[data-fmd-footer]');
    if (footer) initFmdFooter(footer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarBuscador(wrapper) {
    var formularios = wrapper.querySelectorAll('[data-form-buscador], .encabezado-rafas__form-buscador--movil');
    formularios.forEach(function(form) {
      var input = form.querySelector('[data-input-buscar], .encabezado-rafas__input-buscar');

      if (!input) return;

      function actualizarEstado() {
        if (input.value.length > 0) {
          form.classList.add('tiene-texto');
        } else {
          form.classList.remove('tiene-texto');
        }
      }

      input.addEventListener('input', actualizarEstado);
      input.addEventListener('change', actualizarEstado);
      form.addEventListener('reset', function() {
        setTimeout(actualizarEstado, 0);
      });
      actualizarEstado();
    });
  }

  function inicializarEncabezadoRafas(wrapper) {
    var tipo = wrapper.dataset.stickyType;
    if (!tipo || tipo === 'none') return;

    var inner = wrapper.querySelector('[data-encabezado-inner]');
    var placeholder = wrapper.querySelector('[data-encabezado-placeholder]');
    if (!inner || !placeholder) return;

    var scrollAnterior = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;
    var estadoFijo = false;
    var timeoutOcultar = null;

    function actualizarAltura() {
      var altura = inner.offsetHeight;
      if (tipo === 'always') {
        placeholder.style.height = altura + 'px';
      }
      document.documentElement.style.setProperty('--header-height', altura + 'px');
    }

    if (tipo === 'always') {
      wrapper.classList.add('modo-always');
      actualizarAltura();
      setTimeout(actualizarAltura, 100);
      setTimeout(actualizarAltura, 500);
    } else if (tipo === 'on-scroll-up') {
      wrapper.classList.add('modo-subida');
      actualizarAltura();
    }

    window.addEventListener('resize', actualizarAltura);

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(actualizarAltura);
      ro.observe(inner);
    }

    function activarFijo() {
      if (timeoutOcultar) {
        clearTimeout(timeoutOcultar);
        timeoutOcultar = null;
      }
      if (estadoFijo) return;
      wrapper.classList.add('fijo');
      void wrapper.offsetWidth;
      requestAnimationFrame(function() {
        wrapper.classList.add('visible');
      });
      estadoFijo = true;
    }

    function desactivarFijo() {
      if (!estadoFijo) return;
      wrapper.classList.remove('visible');
      timeoutOcultar = setTimeout(function() {
        wrapper.classList.remove('fijo');
        estadoFijo = false;
        timeoutOcultar = null;
      }, 320);
    }

    function manejarScroll() {
      var scrollActual = window.pageYOffset || document.documentElement.scrollTop || 0;
      var diferencia = scrollActual - scrollAnterior;

      if (tipo === 'always') {
        if (scrollActual > 5) {
          wrapper.classList.add('tiene-sombra');
        } else {
          wrapper.classList.remove('tiene-sombra');
        }
      } else if (tipo === 'on-scroll-up') {
        var alturaHeader = inner.offsetHeight;

        if (scrollActual <= 5) {
          if (estadoFijo) {
            desactivarFijo();
          }
          ticking = false;
          scrollAnterior = scrollActual;
          return;
        }

        if (diferencia < -3 && scrollActual > alturaHeader) {
          activarFijo();
        } else if (diferencia > 3) {
          desactivarFijo();
        }
      }

      scrollAnterior = scrollActual;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(manejarScroll);
        ticking = true;
      }
    }, { passive: true });

    manejarScroll();
  }

  function inicializarTodo() {
    var wrappers = document.querySelectorAll('.encabezado-rafas-wrapper');
    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.rafasInicializado === 'true') return;
      wrapper.dataset.rafasInicializado = 'true';
      inicializarEncabezadoRafas(wrapper);
      inicializarBuscador(wrapper);

      var btn = wrapper.querySelector('[data-toggle-buscador-movil]');
      var panel = wrapper.querySelector('[data-buscador-movil]');
      if (btn && panel) {
        btn.addEventListener('click', function() {
          var oculto = panel.hasAttribute('hidden');
          if (oculto) {
            panel.removeAttribute('hidden');
            var input = panel.querySelector('input[type="search"]');
            if (input) setTimeout(function() { input.focus(); }, 50);
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      var btnMega = wrapper.querySelector('[data-abrir-megamenu]');
      if (btnMega) {
        btnMega.addEventListener('click', function() {
          document.dispatchEvent(new CustomEvent('megamenu:abrir'));
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicializarTodo);
  } else {
    inicializarTodo();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.encabezado-rafas-wrapper')) {
      inicializarTodo();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-header02"] && !Shopify.designMode) return;
  try {
    
(function() {
  const contenedores = document.querySelectorAll('.barra-anuncios');
  contenedores.forEach(function(contenedor) {
    const slider = contenedor.querySelector('.barra-anuncios__slider');
    if (!slider) return;

    const mensajes = Array.from(slider.querySelectorAll('.barra-anuncios__mensaje'));
    if (mensajes.length <= 1) return;

    const tipoTransicion = slider.dataset.transition || 'fade';
    const velocidad = (parseInt(slider.dataset.velocidad) || 4) * 1000;

    slider.classList.add('barra-anuncios--' + tipoTransicion);

    let indiceActual = 0;
    let intervalo = null;

    function mostrarMensaje(indice) {
      const anterior = indiceActual;
      indiceActual = indice;

      mensajes[anterior].classList.add('barra-anuncios__mensaje--saliendo');
      mensajes[anterior].classList.remove('barra-anuncios__mensaje--activo');

      setTimeout(function() {
        mensajes[anterior].classList.remove('barra-anuncios__mensaje--saliendo');
      }, 600);

      mensajes[indiceActual].classList.add('barra-anuncios__mensaje--activo');
    }

    function siguiente() {
      const proximoIndice = (indiceActual + 1) % mensajes.length;
      mostrarMensaje(proximoIndice);
    }

    function iniciar() {
      intervalo = setInterval(siguiente, velocidad);
    }

    function pausar() {
      clearInterval(intervalo);
    }

    slider.addEventListener('mouseenter', pausar);
    slider.addEventListener('mouseleave', iniciar);

    iniciar();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dani-seccion4"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-ctf]').forEach(function(seccion) {
      var activo = seccion.dataset.tiltActivo === 'true';
      if (!activo) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia('(hover: none)').matches) return;

      var wrapper = seccion.querySelector('[data-tilt-wrapper]');
      var target = seccion.querySelector('[data-tilt-target]');
      if (!wrapper || !target) return;

      var intensidad = parseFloat(seccion.dataset.tiltIntensidad) || 8;
      var ticking = false;
      var lastX = 0;
      var lastY = 0;

      function actualizar() {
        var rect = wrapper.getBoundingClientRect();
        var x = lastX - rect.left;
        var y = lastY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = ((y - centerY) / centerY) * -intensidad;
        var rotateY = ((x - centerX) / centerX) * intensidad;
        target.style.transform = 'perspective(1200px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale(1.02)';
        ticking = false;
      }

      wrapper.addEventListener('mousemove', function(e) {
        lastX = e.clientX;
        lastY = e.clientY;
        if (!ticking) {
          window.requestAnimationFrame(actualizar);
          ticking = true;
        }
      });

      wrapper.addEventListener('mouseleave', function() {
        target.style.transform = 'perspective(1200px) rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
